<template>
  <div class="page" :class="companyCode">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">

    <header class="header-wrapper">
      <div class="top-bar">
        <div class="container">
          <div class="info-wrapper">
            <div class="social-wrapper">
              <a
                v-for="social in currentBrand.socials"
                :href="social.link"
                class="social-link" :class="social.code"
                :key="social.code"
              >
                <component :is="social.icon" class="social-icon" />
              </a>
            </div>
            <div class="contact-wrapper">
              <a class="contact-item address">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.4125 11.4125C13.8042 11.0208 14 10.55 14 10C14 9.45 13.8042 8.97917 13.4125 8.5875C13.0208 8.19583 12.55 8 12 8C11.45 8 10.9792 8.19583 10.5875 8.5875C10.1958 8.97917 10 9.45 10 10C10 10.55 10.1958 11.0208 10.5875 11.4125C10.9792 11.8042 11.45 12 12 12C12.55 12 13.0208 11.8042 13.4125 11.4125ZM12 19.35C14.0333 17.4833 15.5417 15.7875 16.525 14.2625C17.5083 12.7375 18 11.3833 18 10.2C18 8.38333 17.4208 6.89583 16.2625 5.7375C15.1042 4.57917 13.6833 4 12 4C10.3167 4 8.89583 4.57917 7.7375 5.7375C6.57917 6.89583 6 8.38333 6 10.2C6 11.3833 6.49167 12.7375 7.475 14.2625C8.45833 15.7875 9.96667 17.4833 12 19.35ZM12 22C9.31667 19.7167 7.3125 17.5958 5.9875 15.6375C4.6625 13.6792 4 11.8667 4 10.2C4 7.7 4.80417 5.70833 6.4125 4.225C8.02083 2.74167 9.88333 2 12 2C14.1167 2 15.9792 2.74167 17.5875 4.225C19.1958 5.70833 20 7.7 20 10.2C20 11.8667 19.3375 13.6792 18.0125 15.6375C16.6875 17.5958 14.6833 19.7167 12 22Z" fill="#6E7485"/>
                </svg>
                Վազգեն Սարգսյան 2, Երևան 0010, ՀՀ
              </a>
              <a href="mailto:info@ameriabank.am" class="contact-item email">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 6.5625C21 5.56562 20.19 4.75 19.2 4.75H4.8C3.81 4.75 3 5.56562 3 6.5625V17.4375C3 18.4344 3.81 19.25 4.8 19.25H19.2C20.19 19.25 21 18.4344 21 17.4375V6.5625ZM19.2 6.5625L12 11.0938L4.8 6.5625H19.2ZM19.2 17.4375H4.8V8.375L12 12.9062L19.2 8.375V17.4375Z" fill="#6E7485"/>
                </svg>
                info@ameriabank.am
              </a>
              <a href="tel:+37410561111" class="contact-item phone">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 16.5V20C21 20.5 20.5 21 20 21C10.6 21 3 13.4 3 4C3 3.5 3.5 3 4 3H7.5C8 3 8.5 3.5 8.5 4C8.5 5.2 8.7 6.5 9.1 7.6C9.2 7.9 9.1 8.3 8.9 8.6L6.6 10.8C8 13.6 10.4 15.9 13.2 17.4L15.4 15.2C15.6 15 15.8 14.9 16.1 14.9C16.2 14.9 16.3 14.9 16.4 14.9C17.5 15.3 18.7 15.5 20 15.5C20.5 15.5 21 16 21 16.5Z" fill="#6E7485"/>
                </svg>
                +374 10 56 11 11
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="navbar">
        <div class="container">
          <div class="logo-wrapper">
            <img v-if="isMobile && currentBrand.mobileLogo" :src="currentBrand.mobileLogo" class="mobile-logo" alt="">
            <img v-else :src="currentBrand.logo" alt="">
          </div>
          <div class="tool-wrapper">
            <button class="btn main-transparent-btn">
              Մուտք
            </button>
            <button class="btn main-btn">
              Գրանցում
            </button>
          </div>
        </div>
      </div>
    </header>

    <section class="section-banner" >
      <carousel
        :perPage="1"
        :navigationEnabled="false"
        :loop="true"
        :scrollPerPage="true"
      >
        <slide class="position-relative h-100"
           v-for="(banner, index) in currentBrand.banners"
           :key="index"
        >
          <div class="banner" >
            <div class="bg-image">
              <img :src="isMobile && banner?.bgImageMobile ? banner?.bgImageMobile : banner?.bgImage" alt="">
            </div>
            <div class="container">
              <div class="content">
                <div class="text-wrapper">
                  <h1 class="title">{{ banner?.title }}</h1>
                  <h4 class="sub-title" v-html="banner?.subtitle"></h4>
                </div>
                <div class="btn main-btn" @click="banner.btnAction ? banner.btnAction(_self) : openHowToParticipate()">
                  Ինչպես մասնակցել
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </section>

    <div class="table-info-block">
      <div class="container">
        <h3 class="title">{{ currentBrand.tableInfo.title }}</h3>
        <h5 class="sub-title">{{ currentBrand.tableInfo.subTitle }}</h5>
      </div>
    </div>

    <brand-table :brandCode="companyCode"></brand-table>

    <div class="copyright">
      <div class="logo">
        <svg width="97" height="24" viewBox="0 0 97 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M87.4146 23.5445H91.2779V13.5192C92.0763 11.8736 93.4156 10.9622 95.0897 10.9622C95.6564 10.9622 96.4033 11.0635 96.8926 11.266V7.97484C96.5063 7.79763 95.8882 7.72168 95.27 7.72168C93.5186 7.72168 92.0763 8.65839 91.2779 10.2027V8.00016H87.4146V23.5445Z" fill="#2D3036"/>
          <path d="M64.0027 19.2405C63.5134 20.3038 62.5862 20.9367 61.3757 20.9367C59.6758 20.9367 58.6456 19.7722 58.6456 17.3671V14.6076C58.6456 12.2025 59.65 11.038 61.3757 11.038C62.6119 11.038 63.5134 11.6709 64.0027 12.7342V19.2405ZM54.7822 17.7215C54.7822 22.0253 57.332 24 60.2682 24C62.0196 24 63.3331 23.2911 64.0027 22.2025V23.5443H67.8661V0H64.0027V9.31646C63.3331 8.22785 62.0196 7.51899 60.2682 7.51899C57.332 7.51899 54.7822 9.46835 54.7822 13.7975V17.7215Z" fill="#2D3036"/>
          <path d="M42.4454 13.0638C42.8317 11.8233 43.8877 11.0384 45.3042 11.0384C46.8753 11.0384 47.8025 11.8992 47.8025 14.4815V23.5448H51.6659V13.8486C51.6659 9.74731 49.7342 7.49414 46.3087 7.49414C44.4286 7.49414 43.0635 8.3549 42.4454 9.44351V7.94984H38.582V23.5448H42.4454V13.0638Z" fill="#2D3036"/>
          <path d="M26.1422 13.3413C26.1422 10.0502 31.4993 10.0249 31.4993 13.3413V13.8477H26.1422V13.3413ZM28.7692 20.911C27.2239 20.911 26.3482 20.0249 26.1679 17.797C26.1164 17.2907 26.1422 17.4173 26.1422 16.911H35.3627V13.9743C35.3627 9.94894 32.9159 7.51855 28.8207 7.51855C24.7256 7.51855 22.2788 9.94894 22.2788 13.9743V17.5439C22.2788 21.5692 24.5968 23.9996 28.7692 23.9996C32.5295 23.9996 34.8218 21.9996 35.2081 18.5312L31.2933 18.2781C31.0872 20.1262 30.2115 20.911 28.7692 20.911Z" fill="#2D3036"/>
          <path d="M7.93262 3.79783H13.3671V23.5447H17.591V3.79783H23.0254V0.456055H7.93262V3.79783Z" fill="#2D3036"/>
          <path d="M74.9489 13.3413C74.9489 10.0502 80.3061 10.0249 80.3061 13.3413V13.8477H74.9489V13.3413ZM77.6017 20.911C76.0564 20.911 75.1807 20.0249 75.0004 17.797C74.9489 17.2907 74.9747 17.4173 74.9747 16.911H84.1952V13.9743C84.1952 9.94894 81.7484 7.51855 77.6532 7.51855C73.5581 7.51855 71.1113 9.94894 71.1113 13.9743V17.5439C71.1113 21.5692 73.4293 23.9996 77.6017 23.9996C81.3621 23.9996 83.6543 21.9996 84.0406 18.5312L80.1258 18.2781C79.9197 20.1262 79.044 20.911 77.6017 20.911Z" fill="#2D3036"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.22392 9.82302V23.5445H0V9.82302L2.11196 7.74707L4.22392 9.82302Z" fill="#2D3036"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2.532L2.11196 0.456055L4.22392 2.532V6.17757L2.11196 4.10162L0 6.17757V2.532Z" fill="#2D3036"/>
        </svg>
      </div>
      <div class="text">
        Տենդերների կազմակերպման, մասնակցության և կառավարման միասնական տեխնոլոգիական հարթակ
      </div>
    </div>

    <organisation-guide-modal></organisation-guide-modal>
  </div>
</template>

<script>

import FacebookIcon from '@/components/Icons/facebook.vue'
import LinkedinIcon from '@/components/Icons/linkedin.vue'
import YoutubeIcon from '@/components/Icons/youtube.vue'
import InstagramIcon from '@/components/Icons/instagram.vue'
import XIcon from '@/components/Icons/x.vue'
import TiktokIcon from '@/components/Icons/tiktok.vue'


import isMobile from '@/mixins/isMobileView'
import BrandTable from '@/components/tenders/table/BrandTable'
import vPagination from 'vue-plain-pagination'
import TelegramIcon from "@/components/Icons/telegram.vue";
import { Carousel, Slide } from 'vue-carousel';

import OrganisationGuideModal from '@/components/modals/OrganisationGuideModal.vue'

const brands = {
  ameria: {
    logo: '/assets/landing/images/branding/ameria/logo.svg',
    mobileLogo: '/assets/landing/images/branding/ameria/small-logo.svg',
    primaryColor: '#72BF44',
    bgColor: '#FCFCFC',
    hoverColor: '#5F9F39',
    tableInfo: {title: '«Ամերիաբանկ» ՓԲԸ-ի տենդերները', subTitle: 'Ծանոթացեք ընթացիկ տենդերներին'},
    banners: [{
      bgImage: '/assets/landing/images/branding/ameria/banner.jpg',
      bgImageMobile: '/assets/landing/images/branding/ameria/banner_mobile.jpg',
      title: 'MyAmeria Star',
      subtitle: `Ստեղծիր քո աստղը <br> <b>Սկսիր քո գումարից և քո որոշումներից </b>
                    <br> Բանկային քարտ և հավելված 6-18 տարեկանների համար`,
      btnAction: function (self) {self.openHowToParticipate()}}],
    socials: [
      {
        code: 'facebook',
        link: 'https://www.facebook.com/Ameriabank',
        icon: FacebookIcon
      },
      {
        code: 'linkedin',
        link: 'https://www.linkedin.com/company/ameriabank-cjsc/',
        icon: LinkedinIcon
      },
      {
        code: 'youtube',
        link: 'https://www.youtube.com/user/AmeriabankCJSC',
        icon: YoutubeIcon
      },
      {
        code: 'instagram',
        link: 'https://instagram.com/ameriabank?utm_medium=copy_link',
        icon: InstagramIcon
      },
      {
        code: 'Telegram',
        link: 'https://t.me/ameriabank_cjsc',
        icon: TelegramIcon
      },
      {
        code: 'x',
        link: 'https://x.com/AmeriaBankCJSC',
        icon: XIcon
      },
      {
        code: 'tiktok',
        link: 'https://www.tiktok.com/@ameriabank.cjsc',
        icon: TiktokIcon
      },
    ]
  },
  zcmc: {
    logo: '/assets/landing/images/branding/zcmc/logo.svg',
    primaryColor: '#1F2226',
    bgColor: '#161A20',
    hoverColor: '#1F2226',
    tableInfo: {title: '«ԶՊՄԿ» ՓԲԸ-ի տենդերները', subTitle: 'Ծանոթացեք ընթացիկ տենդերներին'},
    banners: [{
      bgImage: '/assets/landing/images/branding/zcmc/banner.jpg',
      bgImageMobile: '/assets/landing/images/branding/zcmc/banner_mobile.jpg',
      title: '', subtitle: '', btnAction: function (self) {self.openHowToParticipate()} }],
    socials: [
      {
        code: 'facebook',
        link: 'https://www.facebook.com/zcmcofficial/',
        icon: FacebookIcon
      },
      {
        code: 'instagram',
        link: 'https://www.instagram.com/zcmcofficial/',
        icon: InstagramIcon
      },
      {
        code: 'youtube',
        link: 'https://www.youtube.com/@zcmcofficial/',
        icon: YoutubeIcon
      },
      {
        code: 'linkedin',
        link: 'https://www.linkedin.com/company/zcmcofficial/',
        icon: LinkedinIcon
      },
    ]
  }
}

export default {
  components: { vPagination, Carousel, Slide, BrandTable, OrganisationGuideModal },
  props: ['brandCode'],
  mixins: [isMobile],
  data(){
    const companyCode = this.brandCode ?? this.$route.params.brandCode
    return{
      currentBrand: brands[companyCode] ?? {},
      companyCode: companyCode
    }
  },
  methods: {
    openHowToParticipate() {
      this.$modal.show('organisation-guide-modal', {
        title: 'Ինչպե՞ս մասնակցել',
        brandCode: this.companyCode,
        fetchFromApi: true,
        isConfirmable: false,
      });
    }
  }
}
</script>
<style>
.container {
  max-width: 1194px;
  margin: auto;
}
a:hover {
  color: v-bind('currentBrand.primaryColor');
}
.btn {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px 16px;
  line-height: 20px;
  width: max-content;
  transition: 0.3s ease-in-out;
}
.main-btn {
  background: v-bind('currentBrand.primaryColor');
  border: v-bind('currentBrand.primaryColor');
  color: #FFFFFF;
}
.main-btn:hover {
  background: v-bind('currentBrand.hoverColor');
  color: white;
}
.main-inp {
  padding: 8px 12px;
  border: 1px solid #EDEFF2;
  background: #F7F7F7;
  border-radius: 12px;
  min-width: 378px;
}
.main-inp::placeholder {
  color: #888888;
  opacity: 1;
}
.search-inp {
  padding-right: 30px;
}
.top-bar {
  width: 100%;
  background: v-bind('currentBrand.bgColor');
  padding: 12px 0;
  border-bottom: 1px solid #EDEFF2;
}
.top-bar .info-wrapper {
  display: flex;
  justify-content: space-between;
}
.top-bar .social-wrapper {
  display: flex;
  gap: 24px;
}
.top-bar .social-wrapper .social-icon {
  width: 24px;
  fill: #6E7485;
}
.top-bar .social-wrapper .social-icon:hover {
  fill: v-bind('currentBrand.primaryColor');
}

.top-bar .contact-wrapper {
  display: flex;
  gap: 24px;
  color: #595E6B;
  align-items: center;
}
.top-bar .contact-wrapper .contact-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #595E6B;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0;
  text-align: right;
  transition: 0.3s ease-in-out;
}
.top-bar .contact-wrapper .contact-item:hover {
  color: v-bind('currentBrand.primaryColor');
}
.navbar {
  padding: 18px 0;
}
.navbar .logo-wrapper img {
  max-width: 220px;
}
.navbar .logo-wrapper .mobile-logo {
  max-width: 36px;
}
.navbar .tool-wrapper {
  display: flex;
  gap: 16px;
}
.banner {
  min-height: 350px;
}
.banner .bg-image {
  position: absolute;
  width: 100%;
  height: 100%;
}
.banner .bg-image img {
  width: 110%;
  object-fit: cover;
  margin-left: -5%;
}
.banner .content {
  position: relative;
  z-index: 3;
  padding: 50px 0;
}
.banner .text-wrapper {
  display: flex;
  height: 100%;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
}
.banner .text-wrapper .title {
  font-weight: 500;
  font-size: 46px;
  line-height: 60px;
  letter-spacing: 0;
  color: #0E0F12;
  margin: 0;
}
.banner .text-wrapper .sub-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: #40444D;
}
.table-info-block {
  padding: 50px 0 40px;
}

.table-info-block .title {
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0;
  text-align: center;
}

.table-info-block .sub-title {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0;
  text-align: center;
}

.tenders-table  {
  margin-bottom: 32px;
}
.tenders-table .table-tools {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
}
.tenders-table .table-tools .tabs-wrapper {
  display: flex;
  border: 1px solid #DADDE5;
  width: max-content;
  border-radius: 8px;
}

.tenders-table .table-tools .tabs-wrapper .tab-btn {
  width: 138px;
  justify-content: center;
}
.tenders-table .table-tools .search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.tenders-table .table-tools .search-box .icon-wrapper {
  position: absolute;
  right: 6px;
}

.tenders-table .tender-data {
  background: #F7F7F7;
  border-radius: 16px;
}

.tenders-table .tender-data .tender-row {
  margin: 0 20px;
  border-bottom: 1px solid #DADDE5;
}
.tenders-table .tender-data .tender-row .inner-content {
  margin: 0 -20px;
  display: grid;
  grid-template-columns: minmax(200px, 600px) 220px 170px 210px;
}

.tenders-table .tender-data .tender-row:first-child,
.tenders-table .tender-data .tender-row:last-child {
  border: none;
}
.tenders-table .tender-data .tender-row .cell {
  display: flex;
  align-items: center;
  padding: 20px;
  color: #2D3036;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
}

.tenders-table .tender-data .tender-row.heading .cell {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #6E7485;
}
.pagination {
  gap: 8px;
}
.page-item .btn {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #40444D;
  border: 1px solid #DADDE5;
  transition: 0.3s ease-in-out;
  padding: 0 12px;
}
.page-item .btn:hover,
.page-item-active .btn {
  background: v-bind('currentBrand.primaryColor');
  color: white;
  border: 1px solid v-bind('currentBrand.primaryColor');
}
.btn.pagination-link--disable {
  border: none;
  pointer-events: none;
}

.copyright {
  margin-top: 50px;
  background: #F7F7F7;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 26px;
}
.copyright .text {
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  color: #595E6B;
}
@media (max-width: 1200px) {
  .top-bar .contact-wrapper {
    gap: 4px;
  }
  .top-bar .contact-wrapper .contact-item.address {
    display: none;
  }
}
@media (max-width: 991px) {
  .tenders-table .table-tools {
    flex-direction: column;
    gap: 12px;
  }
  .tenders-table .table-tools .tabs-wrapper {
    width: 100%;
  }
  .tenders-table .table-tools .tabs-wrapper .tab-btn {
    width: 50%;
  }
  .tenders-table .table-tools .search-box {
    width: 100%;
  }
  .tenders-table .table-tools .search-inp {
    width: 100%;
  }
  .tenders-table .tender-row.heading {
    display: none;
  }
  .tenders-table .tender-data {
    background: unset;
  }
  .tenders-table .tender-data .tender-row {
    margin: 0 12px;
  }
  .tenders-table .tender-data .tender-row .inner-content {
    display: flex;
    flex-wrap: wrap;
    background: #F7F7F7;
    margin-bottom: 8px;
    border-radius: 16px;
    padding: 16px 0;
  }
  .tenders-table .tender-data .tender-row {
    border-bottom: unset;
    grid-template-columns: unset;
  }
  .tenders-table .tender-data .tender-row .cell {
    padding: 4px 16px;
  }
  .tenders-table .tender-data .tender-row .cell.name {
    width: 100%;
  }
  .tenders-table .tender-data .tender-row .cell.action {
    margin-top: 12px;
    width: 100%;
  }
  .tenders-table .tender-data .tender-row .cell.date {
    width: max-content;
  }
  .tenders-table .tender-data .tender-row .cell.date .date-styles br {
    display: none;
  }
  .tenders-table .tender-data .tender-row .cell.action .main-btn {
    width: 100%;
    justify-content: center;
  }
  .pagination li:first-child .btn, .pagination li:last-child .btn {
    display: none;
  }
}
@media (max-width: 760px) {
  .top-bar .social-wrapper {
    display: none;
  }
  .top-bar .contact-wrapper {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .banner .bg-image{
    position: relative;
  }
  .banner .container{
    border-left: 6px solid v-bind('currentBrand.primaryColor');
  }
  .banner .text-wrapper{
    margin-bottom: 20px;
  }

  .banner .text-wrapper .title {
    font-size: 23px;
    line-height: 32px;
    font-weight: 700;
  }
  .banner .text-wrapper .sub-title {
    font-size: 18px;
    line-height: 26px;
  }
  .banner .content{
    padding: 28px 5px;
  }
  .table-info-block {
    padding: 24px 0 28px;
  }
  .table-info-block .title {
    font-size: 26px;
    line-height: 36px;
  }
  .table-info-block .sub-title {
    font-size: 16px;
    line-height: 24px;
  }
}
@media (max-width: 568px) {
  .top-bar .contact-wrapper {
    flex-direction: column-reverse;
  }
  .container {
    padding: 0 16px;
  }
  .copyright {
    padding: 20px 0 12px;
  }
}

/*** AMERIA ***/
.page.ameria .navbar .logo-wrapper img {
  width: 180px;
}
/*** AMERIA ***/
/*** ZCMC ***/
.page.zcmc .navbar .logo-wrapper img {
  width: 80px;
}
.zcmc .top-bar .social-wrapper .social-icon {
  fill: #ABAEB8;
}
.zcmc .top-bar .social-wrapper .social-icon:hover {
  fill: #FFFFFF;
}
.zcmc .top-bar .contact-wrapper .contact-item {
  color: #ABAEB8;
}
.zcmc .top-bar .contact-wrapper .contact-item:hover {
  color: #FFFFFF;
}
.zcmc .main-btn {
  border-radius: 100px;
}
.zcmc .main-btn:hover {
  background: white;
  color: v-bind('currentBrand.hoverColor');
}
.zcmc .tenders-table .table-tools .tabs-wrapper {
  border-radius: 100px;
}
.zcmc .banner {
  align-items: flex-end;
  display: flex;
}
.zcmc .banner .content {
  align-items: flex-end;
}
.zcmc .banner .content .main-btn {
  background: #FFFFFF;
  color: #161A20;
}
.zcmc .page-item .btn {
  border-radius: 100px;
}
@media (max-width: 768px) {
  .zcmc .banner {
    display: block;
  }
  .zcmc .banner .content .text-wrapper {
    display: none;
  }
  .zcmc .banner .content .main-btn {
    background: v-bind('currentBrand.primaryColor');
    color: white;
    border: 1px solid v-bind('currentBrand.primaryColor');
  }
}
/*** ZCMC ***/

</style>
